import axiosInstance from "auth/FetchInterceptor";
import {
  SETTING_VEHICLE_TYPE_API,
  GET_ALL_VEHICLE_TYPE_API,
} from "constants/ApiConstant";
const SettingVehicleTypeService = {};

SettingVehicleTypeService.getAllVehicleTypeApi = function () {
  return axiosInstance.get(GET_ALL_VEHICLE_TYPE_API, null);
};

SettingVehicleTypeService.createVehicleTypeApi = function (data) {
  return axiosInstance.post(SETTING_VEHICLE_TYPE_API, data);
};

SettingVehicleTypeService.updateVehicleTypeApi = function (data) {
  return axiosInstance.put(SETTING_VEHICLE_TYPE_API, data);
};

SettingVehicleTypeService.deleteVehicleTypeApi = function (id) {
  return axiosInstance.delete(`${SETTING_VEHICLE_TYPE_API}/${id}`, null);
};

export default SettingVehicleTypeService;
